import MainLayout from './main-layout';

export { MainLayout };
